module.exports = {
  age: {
    en: " yo",
    fi: "v",
  },
  MALE: {
    en: "Male",
    fi: "Mies",
  },
  FEMALE: {
    en: "Female",
    fi: "Nainen",
  },
  OTHER: {
    en: "Other",
    fi: "Muu",
  },

  "reset": {
    en: "Info",
    fi: "Tietoa",
  },

  begin: {
    en: "Start by selecting your electoral district",
    fi: "Aloita valitsemalla vaalipiirisi",
  },

  v: {
    en: "Saving from public services vs raising taxes",
    fi: "Julkisten palveluiden leikkaukset vai verojen korotukset",
  },
  pt: {
    en: "Basic income (UBI)",
    fi: "Perustulo eli kansalaispalkka",
  },
  y: {
    en: "Environment vs economic growth",
    fi: "Ympäristö vai talouskasvu",
  },
  yv: {
    en: "More nuclear energy",
    fi: "Lisää ydinvoimaa",
  },
  eu: {
    en: "EU is beneficial",
    fi: "EU:sta on hyötyä",
  },
  m: {
    en: "Multiculturalism",
    fi: "Monikulttuurisuus",
  },
  a: {
    en: "Adoption rights for all couples",
    fi: "Adoptio-oikeudet kaikille pareille",
  },

  'Leikkaukset': {
    en: "Savings",
    fi: "Leikkaukset",
  },
  'Verot': {
    en: "Taxes",
    fi: "Verot",
  },
  'Ei': {
    en: "No",
    fi: "Ei",
  },
  'Kyllä': {
    en: "Yes",
    fi: "Kyllä",
  },
  'Ympäristö': {
    en: "Environment",
    fi: "Ympäristö",
  },
  'Talouskasvu': {
    en: "Economic growth",
    fi: "Talouskasvu",
  },

  skip: {
    en: "Not relevant for me / I'm not sure",
    fi: "Ei väliä / En tiedä",
  },
  "most important": {
    en: "What's most important topic for you?",
    fi: "Mikä on tärkein aihe sinulle?"
  },

  "show more": {
    en: "Show more",
    fi: "Näytä lisää",
  },
  "show more parties": {
    en: "Show more parties",
    fi: "Näytä lisää puolueita",
  },
  "Filter results": {
    en: "Filter candidates",
    fi: "Rajaa ehdokkaita",
  },
  "Age": {
    fi: "Ikä",
  },
  "Gender": {
    fi: "Sukupuoli",
  },
  "Party": {
    fi: "Puolue (sopivuusjärjestyksessä)",
  },
  "matching": {
    fi: "sopivaa",
  },
  "other": {
    fi: "muuta",
  },
  "candidates": {
    fi: "ehdokasta",
  },
  "Different opinion": {
    fi: "Eroava mielipide",
  },
  resultshelp: {
    en: "Results are ordered based on both the candidates' and party's suitability.",
    fi: 'Tulokset on järjestetty sekä ehdokkaan että puolueen sopivuuden mukaan.',
  },
  noopinions: {
    en: "No results, all candidates are shown.",
    fi: 'Ei vastauksia, näytetään kaikki ehdokkaat.',
  },

  info0: {
    en: "Pikavaalikone (quick election compass) is a tool for finding your candidate in the 2019 parliamentary elections. It's so fast that you can complete it in under a minute.",
    fi: "Pikavaalikone on nopea vaalikone eduskuntavaaleihin 2019, jonka voit tehdä alle minuutissa. Vastaa vain 7 kysymykseen ja löydä itsellesi nopeasti sopiva ehdokas.",
  },
  info1: {
    en: " ",
    fi: "",
  },
  info2: {
    en: "Instructions for voting",
    fi: "Ohjeet äänestämiseen.",
  },
  infoUrl: {
    en: "https://vaalit.fi/en/voting",
    fi: "https://vaalit.fi/aanestaminen-ja-aanestyspaikat",
  },

  about: {
    en: "Pikavaalikone was made to be the easiest way to select an election candidate.",
    fi: "Pikavaalikone ",
  },

  contact: {
    en: 'Contact',
    fi: 'Ota yhteyttä',
  },

  or: {
    en: 'or',
    fi: 'tai',
  },

  back: {
    en: '< previous',
    fi: '< edellinen',
  },
  change: {
    en: '< change answers',
    fi: '< muuta vastauksia',
  },

  privacy: {
    en: "This site collects anonymous information on visitor counts and answers. All data is handled inside the EU and it can't be traced to you. If you don't want to give informatino,",
    fi: 'Sivu kerää anonyymisti tietoa sivun käynneistä ja vastauksista. Tietoja käsitellään vain EU:n alueella eikä niitä voida yhdistää sinuun. Jos et halua antaa tietoja,',
  },
  clickhere: {
    en: 'click here',
    fi: 'paina tästä',
  },
}